import { useEffect } from 'react';
import HomeLayout from '../../components/layouts/homelayout';

const OTPrivacyNotice = () => {
  useEffect(() => {
    // Only add the script if it doesn't already exist
    if (!document.getElementById('otprivacy-notice-script')) {
      const script = document.createElement('script');
      script.src = "https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js";
      script.type = "text/javascript";
      script.charset = "UTF-8";
      script.id = "otprivacy-notice-script";
      script.setAttribute('settings', 'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyIsImNvbnRlbnRBcGlVcmwiOiJodHRwczovL3ByaXZhY3lwb3J0YWwub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvZW50ZXJwcmlzZXBvbGljeS9kaWdpdGFscG9saWN5L2NvbnRlbnQiLCJtZXRhZGF0YUFwaVVybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0=');

      script.onload = () => {
        if (window.OneTrust && window.OneTrust.NoticeApi) {
          window.OneTrust.NoticeApi.Initialized.then(function() {
            window.OneTrust.NoticeApi.LoadNotices([
              "https://privacyportal-cdn.onetrust.com/storage-container/232c347b-1315-4c22-9ab5-aac33e15e7a1/privacy-notices/01a684f0-b424-42d5-85c1-ea15d85bb243/published/privacynotice.json"
            ]);
          });
        }
      };

      document.body.appendChild(script);
    } else {
      // If script already loaded, just call the API
      if (window.OneTrust && window.OneTrust.NoticeApi) {
        window.OneTrust.NoticeApi.Initialized.then(function() {
          window.OneTrust.NoticeApi.LoadNotices([
            "https://privacyportal-cdn.onetrust.com/storage-container/232c347b-1315-4c22-9ab5-aac33e15e7a1/privacy-notices/01a684f0-b424-42d5-85c1-ea15d85bb243/published/privacynotice.json"
          ]);
        });
      }
    }
  }, []);

  return (
    <>
      <div className="ot-privacy-notice-language-dropdown-container"></div>
      <div id="otnotice-01a684f0-b424-42d5-85c1-ea15d85bb243" className="otnotice"></div>
    </>
  );
};

const Privacy = () => (
  <HomeLayout>
    <title>Privacy Notice</title>
    <meta name="description" content="Privacy policy for the use of this site." />
    <div className='container' style={{ marginTop: 'calc( var(--site-header-height) + var(--space-s))' }}>
      <OTPrivacyNotice />
    </div>
  </HomeLayout>
  
);

export default Privacy;
